import React from 'react';
import { errorMessagesUtils } from 'services/utils';
import { assignCreativesApi } from '../../../services/api';
import { addIndication, INDICATION_TYPES } from '../../taboola-common-frontend-modules/Indications';
import { FormattedMessage } from '../../taboola-common-frontend-modules/i18n';

const successIndication = {
    message: <FormattedMessage id="creatives.save.success" defaultMessage="Ads successfully updated" />,
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

const generateErrorIndication = (errorObject = {}) => ({
    message: errorMessagesUtils.getErrorMessage(errorObject),
    type: INDICATION_TYPES.ERROR,
    highlight: <FormattedMessage id="creatives.save.error.highlight" defaultMessage="Unable to save changes." />,
});

export const updateLibraryCreatives = (accountId, creativeIds, changes) => dispatch => {
    const ads = {
        ids: creativeIds,
        update: changes,
    };

    return assignCreativesApi
        .updateAds(accountId, ads)
        .then(results => {
            dispatch(addIndication(successIndication));
            return { results };
        })
        .catch(error => {
            dispatch(addIndication(generateErrorIndication(error)));
            return { error };
        });
};
